<div class="form-group d-flex align-items-center mb-0">
    <span
        *ngIf="!isAddButtonShown && !isSendButtonShown"
        class="me-2"
        style="font-weight: 500"
    >
        {{topicTittle}}
    </span>

    <input 
        class="form-control me-1"
        id="email" 
        placeholder="Type user email" 
        style="width: 200px"
        type="text"
        [(ngModel)]="email"
        (input)="queryChange($event)"
    />

    <p-dropdown 
        class="p-dropdown-dark mx-1"
        optionLabel="labelName"
        placeholder="Select a Role" 
        [(ngModel)]="selectedRoleModel" 
        [immutable]="false"
        [options]="userRoles" 
        [showClear]="false" 
        (onChange)="updateState()"
    />

    <button 
        *ngIf="permissions.addUserWithRoleToBusiness && isAddButtonShown" 
        class="btn btn-outline-primary ms-1"
        type="button" 
        [disabled]="!isAddButtonEnabled" 
        (click)="addRoleToUserToBusiness()"
    >
        {{ 'users.addButton' | translate }}
    </button>

    <ng-container *ngIf="isSendButtonShown">
        <input
            class="form-control mx-1"
            placeholder="Name"
            [(ngModel)]="firstName"
        />

        <input
            class="form-control mx-1"
            placeholder="Last name"
            [(ngModel)]="lastName"
        />

        <button 
            *ngIf="permissions.sendInvitationWithRoleToBusiness"
            class="btn btn-outline-primary btn-lg ms-1"
            type="button" 
            [disabled]="!isSendButtonEnabled" 
            (click)="sendInvitation()"
        >
            {{ 'users.sendInvitationButton' | translate }}
        </button>
    </ng-container>
</div>
